//funzione che ritorna la lista dei layer aggiunti da url con accanto le checkbox
import React from 'react'
import CheckBoxAddLayer from './CheckboxLayer'
import Tooltip from '@material-ui/core/Tooltip';
function AddLayerList(props){
  
    const [data,setData] = React.useState([])

    React.useEffect(()=>{
        var arrayData = []
        
         props.data.data.find(element => {const a = element.children.find(x=>x.name==="Name") 
         if (a!== undefined){ arrayData.push(a)}})
        setData(arrayData)
    },[props.data])

    const row = (value,dataLayer,index) =>{
        return <Tooltip title={value} key={index}><tr key={index}><td className={"listRow"}>{value}</td><td><CheckBoxAddLayer value={value} dataLayer={dataLayer}/></td></tr></Tooltip>
    }
    return ( <div className="container">
    <div className="row">
      <div className="col s12 board">
        <table id="simple-board">
        <tbody>
             {data.map((x,index)=>row(x.value,props.data.url,index))}
             </tbody>
         </table>
      </div>
    </div>
  </div>)
}

export default AddLayerList